<dcr-menu
  anchor="ui-speed-dial__button"
  positioning="popover"
  y-offset="8"
  [(open)]="open"
  (openChange)="openChange.emit($event)"
  >
  @for (action of speedDialActions; track action) {
    <dcr-menu-item
      [leadingIcon]="action.icon"
      [label]="action.label"
      (click)="action.handler()"
      data-cy="speed-dial-action"
    ></dcr-menu-item>
  }
</dcr-menu>
<dcr-fab [icon]="icon" [label]="label" id="ui-speed-dial__button"></dcr-fab>
